import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { useTranslation } from "react-i18next";

import { Dialog } from "../../core/Dialog/Dialog";
import { Typography } from "../../core/Typography/Typography";
import { useStyles } from "./AppReloadPrompt.style";
import {
  TypographyVariant,
  TypographyColor,
} from "../../../constants/typography";

export const AppReloadPrompt = (): JSX.Element => {
  const [isRefreshing, setIsRefreshing] = useState(false);
  const { t } = useTranslation();
  const classes = useStyles();
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(registration) {
      console.warn(`SW Registered: ${registration}`);
    },
    onRegisterError(error) {
      console.error("SW registration error", error);
    },
  });

  const onClose = (): void => {
    setNeedRefresh(false);
  };

  const onRefresh = (): void => {
    setIsRefreshing(true);
    updateServiceWorker(true);
  };

  return (
    <Dialog
      mainAction={{
        text: isRefreshing ? "Refreshing..." : "Refresh",
        onClick: onRefresh,
        disabled: isRefreshing,
        loading: isRefreshing,
        id: "refresh",
      }}
      secondAction={{
        text: "Close",
        onClick: onClose,
        disabled: isRefreshing,
        id: "close-dialog",
        "data-button-sound": "back",
      }}
      open={needRefresh}
    >
      <div className={classes.content}>
        <Typography
          variant={TypographyVariant.BodyB3Bold}
          className={classes.title}
        >
          New version available!
        </Typography>
        <Typography
          variant={TypographyVariant.BodyB5Regular}
          color={TypographyColor.Silver}
          className={classes.description}
        >
          Please refresh to see the latest changes.
        </Typography>
      </div>
    </Dialog>
  );
};
